var React = require('react');

function IconTime (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M13.988 2A12 12 0 1 0 26 14 11.994 11.994 0 0 0 13.988 2zM14 23.6a9.6 9.6 0 1 1 9.6-9.6 9.6 9.6 0 0 1-9.6 9.6zM14.6 8h-1.8v7.2l6.3 3.78.9-1.48-5.4-3.2z","transform":"translate(-2 -2)"}));
}

IconTime.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconTime;

IconTime.default = IconTime;
